import { forwardRef } from 'react';
import { iconMap } from './icon-map.js';
import type { IconProps, IconVariant } from './types.js';

const SIZE_MAP = {
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
};

const VARIANT_MAP: Record<IconVariant, string> = {
  default: 'text-current',
  muted: 'text-zinc-400',
  accent: 'text-emerald-500',
  destructive: 'text-red-500',
  success: 'text-emerald-500',
};

export const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ name, size = 'md', variant = 'default', className, ...rest }, ref) => {
    const IconComponent = iconMap[name];

    if (!IconComponent) {
      if (import.meta.env.DEV) {
        console.warn(`[Icon] Unknown icon name: "${name}"`);
      }
      return null;
    }

    const resolvedSize = SIZE_MAP[size];
    const mergedClassName = [VARIANT_MAP[variant], className].filter(Boolean).join(' ');

    return <IconComponent ref={ref} size={resolvedSize} className={mergedClassName} {...rest} />;
  },
);

Icon.displayName = 'Icon';
